const data = [
  // { name: 'Meu Perfil', icon: 'mdi-account-edit-outline', route: '/profile' },
]

export default [...data]
